<template>
  <el-dialog title="发票红冲" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false" :before-close="handleClose" @open="handleOpen">
    <el-form :model="formData" :rules="formRules" ref="invoiceForm" label-width="120px" size="small">

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="红冲发票号">
            <el-input v-model="formData.invoiceNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票日期">
            <el-date-picker v-model="formData.invoiceTime" type="date" value-format="yyyy-MM-dd" disabled style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="申请人" prop="applicantName">
            <el-input v-model="formData.applicantName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票主体" prop="invoiceSubject">
            <el-select v-model="formData.invoiceSubject" placeholder="请选择开票主体" style="width: 100%;" @change="handleInvoiceEntityChange">
              <el-option label="晨宇安全科技集团有限公司" value="晨宇安全科技集团有限公司"></el-option>
              <el-option label="晨宇安全科技集团有限公司泉州分公司" value="晨宇安全科技集团有限公司泉州分公司"></el-option>
              <el-option label="晨宇安全科技集团有限公司漳州分公司" value="晨宇安全科技集团有限公司漳州分公司"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="使用单位名称" prop="useUntName">
            <el-input v-model="formData.useUntName" placeholder="请输入单位名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票单位名称" prop="invoiceUnitName">
            <el-input v-model="formData.invoiceUnitName" placeholder="请输入开票单位名称" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="客户名称" prop="compName">
            <el-input v-model="formData.compName" placeholder="请输入客户名称" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="开票类型" prop="invoiceType">
            <el-select v-model="formData.invoiceType" placeholder="请选择开票类型" style="width: 100%;">
              <el-option label="普通发票" :value="0"></el-option>
              <el-option label="专用发票" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="税率" prop="taxRate">
            <el-select v-model="formData.taxRate" placeholder="请选择税率" style="width: 100%;" @change="handleTaxRateChange">
              <el-option label="1%" :value="0.01"></el-option>
              <el-option label="3%" :value="0.03"></el-option>
              <el-option label="6%" :value="0.06"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票金额" prop="invoiceAmount">
            <el-input v-model="formData.invoiceAmount" placeholder="请输入开票金额" @input="handleInvoiceAmountChange" oninput="value=value.replace(/[^\d.]/g,'')">
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="不含税金额">
            <el-input v-model="formData.taxFreeAmount" disabled>
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税额">
            <el-input v-model="formData.taxAmount" disabled>
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="开户银行" prop="bankName">
            <el-input v-model="formData.bankName" placeholder="请输入开户银行" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input v-model="formData.bankAccount" placeholder="请输入银行账号" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="地址" prop="address">
            <el-input v-model="formData.address" placeholder="请输入地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入电话" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="税号" prop="taxNo">
            <el-input v-model="formData.taxNo" placeholder="请输入税号" />
          </el-form-item>
        </el-col>
        
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注" />
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryInvoiceDetail, redReversalInvoice } from '@/api/contract/contract';

export default {
  name: 'RedReversalDialog',
  data () {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 提交加载状态
      submitLoading: false,
      // 表单数据
      formData: {
        id: undefined,
        applyNo: '', // 申请号
        applyTime: '', // 申请时间
        invoiceSubject: '', // 开票主体
        useUntName: '', // 单位名称
        compName: '', // 客户名称
        taxNo: '', // 税号
        taxRate: '', // 税率
        invoiceAmount: '', // 开票金额（含税）
        taxFreeAmount: '', // 不含税金额
        taxAmount: '', // 税额
        invoiceUnitName: '', // 开票单位名称
        invoiceType: '', // 开票类型 0=普通发票，1=专用发票
        bankName: '', // 开户银行
        bankAccount: '', // 银行账号
        applicantName: '', // 申请人姓名（不可修改）
        address: '', // 地址
        phone: '', // 电话
        invoiceNo: '', // 红冲发票号（不可修改）
        invoiceTime: '', // 开票日期（不可修改）
        remark: '', // 备注
        oidNoList: [], // 电梯识别码列表
        entrustNumList: [], // 委托号列表
        totalEquipment: null // 设备台数
      },
      // 表单验证规则
      formRules: {
        invoiceSubject: [
          { required: true, message: '请选择开票主体', trigger: 'change' }
        ],
        useUntName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        taxNo: [
          { required: true, message: '请输入税号', trigger: 'blur' }
        ],
        taxRate: [
          { required: true, message: '请选择税率', trigger: 'change' }
        ],
        invoiceAmount: [
          { required: true, message: '请输入开票金额', trigger: 'blur' }
        ],
        invoiceUnitName: [
          { required: true, message: '请输入开票单位名称', trigger: 'blur' }
        ],
        invoiceType: [
          { required: true, message: '请选择开票类型', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    /**
     * 打开弹窗
     * @param {Object} rowData - 行数据，需要包含 id
     */
    openDialog (rowData) {
      this.dialogVisible = true;
      if (rowData && rowData.id) {
        this.loadFormData(rowData);
      }
    },

    /**
     * 加载表单数据
     * @param {Object} rowData - 行数据
     */
    loadFormData (rowData) {
      if (!rowData || !rowData.id) return;

      // 调用详情 API 获取完整数据
      queryInvoiceDetail(rowData.id).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const data = res.additionalData;
          this.formData = {
            id: data.id,
            applyNo: data.applyNo || '',
            applyTime: data.applyTime || '',
            invoiceSubject: data.invoiceSubject || '',
            useUntName: data.useUntName || '',
            taxNo: data.taxNo || '',
            compName: data.compName || '',
            taxRate: data.taxRate || '',
            invoiceAmount: data.invoiceAmount || '',
            taxFreeAmount: data.taxFreeAmount || '',
            taxAmount: data.taxAmount || '',
            invoiceUnitName: data.invoiceUnitName || '',
            invoiceType: data.invoiceType,
            bankName: data.bankName || '',
            bankAccount: data.bankAccount || '',
            applicantName: data.applicantName || '',
            address: data.address || '',
            phone: data.phone || '',
            invoiceNo: data.invoiceNo || '',
            invoiceTime: data.invoiceTime || '',
            remark: data.remark || '',
            oidNoList: data.oidNoList || [],
            entrustNumList: data.entrustNumList || [],
            totalEquipment: data.totalEquipment
          };
        } else {
          this.$message.error((res && res.retMsg) || '获取发票详情失败');
        }
      }).catch(error => {
        console.error('获取发票详情失败:', error);
        this.$message.error('获取发票详情失败');
      });
    },

    /**
     * 弹窗打开时的回调
     */
    handleOpen () {
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.invoiceForm) {
          this.$refs.invoiceForm.clearValidate();
        }
      });
    },

    /**
     * 关闭弹窗
     */
    handleClose () {
      this.dialogVisible = false;
      this.resetForm();
    },

    /**
     * 重置表单
     */
    resetForm () {
      if (this.$refs.invoiceForm) {
        this.$refs.invoiceForm.resetFields();
      }
      this.formData = {
        id: undefined,
        applyNo: '',
        applyTime: '',
        invoiceSubject: '',
        useUntName: '',
        taxNo: '',
        compName: '',
        taxRate: '',
        invoiceAmount: '',
        taxFreeAmount: '',
        taxAmount: '',
        invoiceUnitName: '',
        invoiceType: '',
        bankName: '',
        bankAccount: '',
        applicantName: '',
        address: '',
        phone: '',
        invoiceNo: '',
        invoiceTime: '',
        remark: '',
        oidNoList: [],
        entrustNumList: [],
        totalEquipment: null
      };
    },

    /**
     * 开票主体变化时的处理
     * 总公司默认税率6%，分公司默认税率1%
     */
    handleInvoiceEntityChange (value) {
      if (value === '晨宇安全科技集团有限公司') {
        this.formData.taxRate = 0.06; // 6%
      } else {
        this.formData.taxRate = 0.01; // 1%
      }
      // 税率变化后重新计算
      this.calculateTax();
    },

    /**
     * 税率变化时的处理
     */
    handleTaxRateChange () {
      this.calculateTax();
    },

    /**
     * 开票金额变化时的处理
     */
    handleInvoiceAmountChange () {
      this.calculateTax();
    },

    /**
     * 计算税额和不含税金额
     * 计算公式：
     * 不含税金额 = 开票金额 / (1 + 税率)
     * 税额 = 开票金额 - 不含税金额
     */
    calculateTax () {
      const invoiceAmount = parseFloat(this.formData.invoiceAmount);
      const taxRate = parseFloat(this.formData.taxRate);

      if (isNaN(invoiceAmount) || isNaN(taxRate) || invoiceAmount <= 0 || taxRate < 0) {
        this.formData.taxFreeAmount = '';
        this.formData.taxAmount = '';
        return;
      }

      // 计算不含税金额（税率已经是小数形式，如 0.06）
      const taxFreeAmount = invoiceAmount / (1 + taxRate);
      // 计算税额
      const taxAmount = invoiceAmount - taxFreeAmount;

      // 保留两位小数
      this.formData.taxFreeAmount = taxFreeAmount.toFixed(2);
      this.formData.taxAmount = taxAmount.toFixed(2);
    },

    /**
     * 提交表单
     */
    handleSubmit () {
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.submitRedReversal();
        } else {
          this.$message.warning('请完善必填项');
          return false;
        }
      });
    },

    /**
     * 提交红冲申请
     */
    submitRedReversal () {
      const submitData = {
        // applyNo: this.formData.applyNo || '',
        invoiceSubject: this.formData.invoiceSubject,
        useUntName: this.formData.useUntName,
        taxNo: this.formData.taxNo,
        compName: this.formData.compName,
        taxRate: this.formData.taxRate,
        invoiceAmount: this.formData.invoiceAmount,
        taxFreeAmount: this.formData.taxFreeAmount,
        taxAmount: this.formData.taxAmount,
        applyTime: this.formData.applyTime || '',
        applicantName: this.formData.applicantName,
        oidNoList: this.formData.oidNoList || [],
        entrustNumList: this.formData.entrustNumList || [],
        totalEquipment: this.formData.totalEquipment,
        address: this.formData.address,
        phone: this.formData.phone,
        invoiceNo: this.formData.invoiceNo,
        invoiceTime: this.formData.invoiceTime,
        bankName: this.formData.bankName,
        bankAccount: this.formData.bankAccount,
        invoiceUnitName: this.formData.invoiceUnitName,
        invoiceType: this.formData.invoiceType,
        remark: this.formData.remark,
        originApplyNo: this.formData.applyNo
      };

      redReversalInvoice(submitData).then(res => {
        if (res && res.retCode === 'ok') {
          this.$message.success('红冲申请成功');
          this.handleClose();
          this.$emit('refresh');
        } else {
          this.$message.error((res && res.retMsg) || '红冲申请失败');
        }
      }).catch(error => {
        console.error('红冲申请失败:', error);
        this.$message.error('红冲申请失败');
      }).finally(() => {
        this.submitLoading = false;
      });
    }
  }
};
</script>

<style scoped>
</style>
